import { Component } from '@angular/core';

import { User } from '@recruitee/http-types';
import { TranslatePipe } from '@recruitee/i18n';

import { AvatarComponent } from '../../../common/avatar/avatar.component';

/*
 eslint-disable
 @typescript-eslint/consistent-type-assertions,
 @angular-eslint/no-inputs-metadata-property,
*/

@Component({
  standalone: true,
  imports: [AvatarComponent, TranslatePipe],
  template: `
    @if (user && !user.anonymizedAt) {
      <rt-avatar
        [type]="user?.hasAvatar ? 'image' : 'initials'"
        size="small-x"
        [imageSrc]="user.photoThumbUrl"
        [initials]="user?.initials"
        margin-right-small-xx
        context="admin"
      >
      </rt-avatar>
    }
    @if (!user || user.anonymizedAt) {
      <rt-avatar type="icon" size="small-x" context="admin" iconName="person" margin-right-small-xx>
      </rt-avatar>
    }
    {{
      user && !user.anonymizedAt
        ? user.firstName + ' ' + user.lastName
        : ('app.common.deleted_user' | translate)
    }}
  `,
  styleUrls: ['./user-cell.component.less'],
  inputs: UserCellComponent.NgInputs,
})
export class UserCellComponent {
  public static NgInputs = ['user' as const];
  public user: User;
}
